import { FormControlLabel, Switch as MuiSwitch } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'

interface SwitchProps {
  name: string
  checked?: boolean
  label?: any
  onChange?: any
  error?: string
  disabled?: boolean
}

export const SwitchC = (props: SwitchProps) => {
  const { name, onChange, label, error = '', disabled } = props
  const { formState } = useFormContext()

  const err = { message: error } || _get(formState.errors, name)

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FieldWrapper error={err}>
          <FormControlLabel
            label={label}
            control={
              <MuiSwitch
                {...field}
                checked={!!field.value}
                disabled={!!disabled}
                onChange={(e) => {
                  field.onChange(e.target.checked)
                  onChange?.(e)
                }}
              />
            }
          />
        </FieldWrapper>
      )}
    />
  )
}
